import { useEffect, useState } from "react";
import {
  Stack,
  Paper,
  SvgIcon,
  Box,
  Grid,
  Typography,
} from "@mui/material";
import { LoadingButton as Button } from "@mui/lab";
import _ from "lodash";
import { useParams, useLocation } from "react-router-dom";
import {
  SystemUpdateAlt as DownloadIcon,
  WhatsApp as WhatsAppIcon,
  ForwardToInboxOutlined as EmailIcon,
} from "@mui/icons-material";
import { useApi, useIsInQuickLink } from "../../utils/hooks";
import MenssageSucces from "./MenssageSucces";
import DataDetails from "./DataDetails";
import LoadingSpinner from "../../../src/utils/LoadingSpinner";
import Exporter from "./Exporter";
import { saveAs } from "file-saver";
import TitleHeadSess from "../../utils/TitleHeadSess";
import { ErrorAlert } from "../../utils";
import CancelButton from "./CancelButton";
import RepeaterButton from "./RepeaterButton";
import Promise from "bluebird";
import useFirstMedicalDocument from "./hooks/useFirstMedicalDocument";

const SingleDocumentActions = ({ medicalDocuments, ...props }) => {
  const medicalDocument = useFirstMedicalDocument(medicalDocuments);

  if (_.size(medicalDocuments) != 1) return;
  
  return (
    <>
      <RepeaterButton {...props} medicalDocument={medicalDocument} />
      <CancelButton {...props} medicalDocument={medicalDocument} />
    </>
  );
};

const DetailsDocument = () => {
  const { id } = useParams();
  const location = useLocation();
  const [failed, setFailed] = useState(false);
  const { createdMedicalDocuments, showSuccess, backPath } = location.state || {};
  const api = useApi();
  const [medicalDocuments, _setMedicalDocuments] = useState();
  const setMedicalDocuments = medicalDocuments => _setMedicalDocuments(_.castArray(medicalDocuments));
  const [method, setMethod] = useState("pdf");
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [failedfailedDocumentDetails, setFailedfailedDocumentDetails] = useState(false);
  const isInQuickLink = useIsInQuickLink();
  const medicalDocument = useFirstMedicalDocument(medicalDocuments);

  const toggleOpen = () => setOpen(!open);

  useEffect(() => {
    if (createdMedicalDocuments) {
      setMedicalDocuments(createdMedicalDocuments);
      setIsLoading(false);
    } else {
      if (id) {
        api.medicalDocument(id)
          .tap(medicalDocument => setMedicalDocuments(medicalDocument))
          .tap(() => setIsLoading(false))
          .catch(() => {
            setFailedfailedDocumentDetails(true);
            setIsLoading(false);
          });
      }
    }
  }, [createdMedicalDocuments, id]);

  if (isLoading) return <LoadingSpinner isLoading={isLoading} absolute />;

  if (failedfailedDocumentDetails)
    return (
      <ErrorAlert
        show={failedfailedDocumentDetails}
        message="La orden o receta no existe"
      />
    );

  const saveDocument = () => {
    setIsSaving(true);
    Promise.each(medicalDocuments, ({ id, url }) => {
      const fileName = id;
      return fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          saveAs(blob, `${fileName}.pdf`);
        })
    })
    .catch((error) => setFailed(true))
    .finally(() => setIsSaving(false));
  };

  const onShare = method => {
    setMethod(method);
    toggleOpen();
  };

  const exportButtons = [
    {
      name: "Descargar PDF",
      variant: "outlined",
      icon: <DownloadIcon />,
      method: "pdf",
      onClick: saveDocument,
      loading: isSaving
    },
    {
      name: "Enviar por Whatsapp",
      variant: "contained",
      icon: <WhatsAppIcon />,
      onClick: () => onShare("ownWhatsapp")
    },
    {
      name: "Enviar por E-Mail",
      variant: "contained",
      icon: <EmailIcon />,
      method: "email",
      onClick: () => onShare("email")
    },
  ];

  const typeText = medicalDocument.type === "prescription" ? "receta" : "orden";
  const title = `Detalle de ${typeText} | `;
  const urlRedirect = backPath || "/prescriptions";
  const iconTitle = backPath == "/" ? "Ir al Inicio" : "Volver";
  const mesaggeSuccess = showSuccess && `La ${typeText} ha sido generada con éxito!`;

  return (
    <Stack
      width="100%"
      spacing="1rem"
      sx={{ p: { xs: "1rem", sm: "2rem" }, mt: { xs: "1rem" } }}
    >
      <Box sx={{ display: "flex" }}>
        <TitleHeadSess
          title={title}
          iconTitle={iconTitle}
          id={_.map(medicalDocuments, "id")}
          urlRedirect={urlRedirect}
        />

        <SingleDocumentActions medicalDocuments={medicalDocuments} setMedicalDocument={setMedicalDocuments} backPath={backPath} />
      </Box>

      <Paper
        variant="outlined"
        width="100%"
        sx={{
          p: { xs: "20px 10px", sm: "20px 40px" },
          borderRadius: 3,
          mb: 7,
        }}
      >
        <Grid item container spacing={3}>
          {showSuccess && (
            <Grid item sm={12}>
              <MenssageSucces mesaggeSuccess={mesaggeSuccess} />
            </Grid>
          )}

          <Grid item sm={12}>
            <DataDetails medicalDocuments={medicalDocuments} />
          </Grid>
        </Grid>
      </Paper>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "column", md: "row" },
          justifyContent: "center",
          pb: 5,
        }}
      >
        {exportButtons.map(({ variant, name, icon, onClick, loading }) => (
          <Button
            key={name}
            variant={variant}
            sx={{ mt: 1, mr: 1, ml: 1 }}
            onClick={onClick}
            loading={loading}
          >
            {name}
            <SvgIcon sx={{ fontSize: 20, ml: 1 }}>{icon}</SvgIcon>
          </Button>
        ))}
      </Box>
      {isInQuickLink &&
        <Stack alignItems="center">
          <Typography>Una vez que compartas el documento, podrás cerrar esta ventana.</Typography>
        </Stack>
      }
      <Exporter
        medicalDocuments={medicalDocuments}
        method={method}
        onClose={toggleOpen}
        open={open}
        setMethod={setMethod}
        setFailed={setFailed}
        failed={failed}
      />
    </Stack>
  );
};

export default DetailsDocument;
